// extracted by mini-css-extract-plugin
module.exports = {"main":"main-PCUB0"};